import Env from '../env.js';
import * as Base from '../../base/mbase.js';
import initCommunication from './communication.js';
function urlRegEx(url) {
  // 如果加上/g参数，那么只返回$0匹配。也就是说arr.length = 0
  const re = /(\w+):\/\/([^:|/]+)(:\d*)?(.*\/)([^#|?|\n]+)?(#.*)?(\?.*)?/i;
  // re.exec(url);
  const arr = url.match(re);
  return arr;
}

function getUrlPath(url) {
  // 获取url路径部分
  const arr = urlRegEx(url);
  url = (arr[2] || '') + (arr[3] || '') + (arr[4] || '') + (arr[5] || '');
  return url;
}

let exportData = {};
if(!Env.isCSR) {
  const win = window; // 不能top，因为页面可能在管理端以iframe形式存在，top.xx会报错
  win.WxGameJsCoreBridge = win.WxGameJsCoreBridge || {};

  // 只初始化一次
  if(!win.WxGameJsCoreBridge.isInited) {
    // 初始化通信
    initCommunication();
    win.WxGameJsCoreBridge.isInited = true;
    
    win.WxGameJsCoreBridge.hadJscoreInited = function() {
      let isInited = false;
      // IOS实现__jscore_state__有点异常，xiaobo让直接判断WxGameJsCoreNative是否存在
      if(Env.isiOS) {
        isInited = !!window.WxGameJsCoreNative && window === top;
      }else{
        isInited = window.__jscore_state__ === 'inited' && window === top;
      }

      return isInited
    }
    win.WxGameJsCoreBridge.renderedUrls = [];
    win.WxGameJsCoreBridge.preRender = function(param) {
      if(!win.WxGameJsCoreBridge.hadJscoreInited()) {
        logError(`预渲染 ${window.__jscore_state__} ${!!window.WxGameJsCoreNative} ${JSON.stringify(param)} jscore 未ready`)
        return Promise.reject();
      }
      return new Promise((resolve, reject) => {
        if(typeof param.htmlUrl === 'string' && param.htmlUrl.length > 0) {
          // 支持透明顶
          // 先抹除透明顶参数
          param.htmlUrl = Base.removeQueryStringKey("wechat_immersive", param.htmlUrl);
          param.htmlUrl = Base.removeQueryStringKey("immersivePageBgIsDark", param.htmlUrl);
          param.htmlUrl = Base.removeQueryStringKey("immersiveUIStyle", param.htmlUrl);
          if (window?.WXGAME?.GlobalConfig?.router?.checkNeedImmersiveParamInUrl(param.htmlUrl) ) { 
            param.htmlUrl += `${param.htmlUrl.indexOf('?') === -1 ? '?' : '&'}wechat_immersive=1&immersivePageBgIsDark=1&immersiveUIStyle=1&`;
          }
  
          // jscore内没有darkmode参数，暂时预渲染时传递一下，支持参数强制写死
          param.isDarkMode = typeof param.isDarkMode === 'undefined' ? Env.isDarkMode : param.isDarkMode;
          win.WxGameJsCoreBridge.postMessage('preRender', param, function(res) {
            win.WxGameJsCoreBridge.renderedUrls.push(param.htmlUrl);
            resolve(res);
          });
        }else{
          reject();
          console.error('preRender必须传htmlUrl');
        }
      });
    }
    win.WxGameJsCoreBridge.hadPrerendered = function (url) {
      url = getUrlPath(url);
      return win.WxGameJsCoreBridge.renderedUrls.some(_url => {
        if(url === getUrlPath(_url)) {
          return true;
        }
      });
    }
    win.WxGameJsCoreBridge.openUrl = function(param) {
      if(!win.WxGameJsCoreBridge.hadJscoreInited()) {
        return Promise.reject();
      }
      return new Promise((resolve, reject) => {
        win.WxGameJsCoreBridge.postMessage('openUrl', param, function(res) {
          resolve(res);
        });
      });
    }
  }

  exportData = win.WxGameJsCoreBridge;
}else{
  exportData = {};
}
export default exportData;


